import FeatherDrift from "@/components/FeatherDrift";

export default function PageShell({ children }) {
  // KALKI scroll-fix: the outer wrapper MUST NOT use `overflow-hidden`
  // (it clips the whole page on Android and prevents vertical scrolling
  // once content exceeds 100dvh). We only clip the X-axis via the global
  // `.App` rule in App.css. The ambient grid/halos/feathers are already
  // `position: fixed` and `pointer-events: none`, so they do not need a
  // clipping parent to stay inside the viewport.
  return (
    <div className="kalki-page-shell relative min-h-[100dvh] w-full bg-white flex flex-col">
      {/* Edge-to-edge dotted grid with gentle drift */}
      <div aria-hidden className="fixed inset-0 kalki-grid grid-drift opacity-60 pointer-events-none" />

      {/* Ambient golden halos (with slow pulse) */}
      <div
        aria-hidden
        className="kalki-halo halo-pulse"
        style={{ top: "-8vw", left: "-6vw", width: "38vw", height: "38vw", maxWidth: 520, maxHeight: 520 }}
      />
      <div
        aria-hidden
        className="kalki-halo halo-pulse-slow"
        style={{ bottom: "-10vw", right: "-8vw", width: "42vw", height: "42vw", maxWidth: 620, maxHeight: 620, opacity: 0.75 }}
      />

      {/* Floating peacock feathers */}
      <FeatherDrift />

      <div className="relative z-10 flex flex-col flex-1 min-h-[100dvh]">
        {children}
      </div>
    </div>
  );
}
